import type { VFC } from 'react';
import { Divider } from 'antd';

export const FilterDivider: VFC = () => <Divider type="vertical" />;
